import React from 'react';
import { block } from '../utils/cn';
import { warnOnce } from '../utils/warn';
const b = block('button');
function warnAboutPhysicalValues() {
    warnOnce('[Button.Icon] Physical values (left, right) of "side" property are deprecated. Use logical values (start, end) instead.');
}
export const ButtonIcon = ({ side, className, children }) => {
    let sideMod = side;
    if (sideMod === 'left') {
        warnAboutPhysicalValues();
        sideMod = 'start';
    }
    if (sideMod === 'right') {
        warnAboutPhysicalValues();
        sideMod = 'end';
    }
    return (React.createElement("span", { className: b('icon', {
            side: sideMod,
        }, className) },
        React.createElement("span", { className: b('icon-inner') }, children)));
};
ButtonIcon.displayName = 'Button.Icon';
